import { useFetchHouseConsignment } from '../api/fetchHouseConsignment'
import useSaveHouseConsignmentForm from './useSaveHouseConsignmentForm'
import { useFetchHouseConsignmentDocuments } from '../../house-consignment-document/api/fetchHouseConsignmentDocuments'

function useHouseConsignment(id: number | null, transitOperationId: number, consignmentId: number) {
  const { data: houseConsignment, isFetching: isHouseConsignmentLoading } = useFetchHouseConsignment(id)
  const { data: houseConsignmentDocuments, isFetching: isHouseConsignmentDocumentsLoading } = useFetchHouseConsignmentDocuments(id)
  const { saveHouseConsignmentFormValues } = useSaveHouseConsignmentForm(
    id,
    transitOperationId,
    consignmentId,
    houseConsignmentDocuments ?? [],
  )

  return {
    houseConsignment,
    houseConsignmentDocuments,
    isLoading: isHouseConsignmentLoading || isHouseConsignmentDocumentsLoading,
    saveHouseConsignmentFormValues,
  }
}

export default useHouseConsignment
